import { render, staticRenderFns } from "./OptionTagBadge.vue?vue&type=template&id=5a5120fd&scoped=true&"
import script from "./OptionTagBadge.vue?vue&type=script&lang=js&"
export * from "./OptionTagBadge.vue?vue&type=script&lang=js&"
import style0 from "./OptionTagBadge.vue?vue&type=style&index=0&id=5a5120fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5120fd",
  null
  
)

export default component.exports